import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-page';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getPagelist();
  }


  deletePage = (id) => {
    confirmAlert({
      title: 'Delete Page',
      message: 'Are you sure to delete the Page?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deletePage(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.PageList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const page = this.props.PageList.filter((item) => item.Title.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'Title',
      text: 'Page Name'
    }, {
      dataField: 'SlugURL',
      text: 'Slug URL'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/page-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deletePage(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Page" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-file-alt cardTitle"> Page</span> */}
                    <SearchBar
                      placeholder="Search by Page Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <Button
                      className="btn btn-sm btn-secondary ml-3"
                      onClick={() => this.props.history.push('/page-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">

                <BootstrapTable
                  keyField="Id"
                  data={page}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Page.defaultProps = {
  tableLoading: false,
  PageList: null,
  getPagelist: null,
  deletePage: null
};

Page.propTypes = {
  tableLoading: PropTypes.bool,
  PageList: PropTypes.array,
  getPagelist: PropTypes.func,
  deletePage: PropTypes.func
};

const mapStateToProps = ({ page }) => ({
  tableLoading: page.tableLoading,
  PageList: page.pageList
});

const mapDispatchToProps = (dispatch) => ({

  getPagelist: () => dispatch(actions.fetchPage()),
  deletePage: (id) => dispatch(actions.deletePage(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Page);
